module.exports = __webpack_public_path__ + "img/p161.bd5dbac6.png";